document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[id^="tolstoy-video-carousel-"]');

  sections.forEach(section => {
    const sectionId = section.id.replace('tolstoy-video-carousel-', '');

    const swiperEl = section.querySelector('.tolstoy-video-swiper');
    const popup = document.getElementById(`video-popup-${sectionId}`);
    const popupVideo = document.getElementById(`popup-video-${sectionId}`);
    const popupProducts = document.getElementById(`popup-products-${sectionId}`);
    const closeBtn = document.getElementById(`popup-close-${sectionId}`);
    const progressBar = popup?.querySelector('.popup-progress-bar') || null;
    const pauseBtn = popup?.querySelector('.pause-btn') || null;
    const viewProductsBtn = popup?.querySelector('.popup-view-products') || null;
    const popupPrev = popup?.querySelector('.popup-prev') || null;
    const popupNext = popup?.querySelector('.popup-next') || null;

    if (!swiperEl || !popup || !popupVideo) {
      console.warn(`Skipping section ${sectionId}: missing required elements`);
      return;
    }

    // Initialize Swiper
    const swiper = new Swiper(swiperEl, {
      slidesPerView: parseFloat(section.dataset.show_desktop) || 4,
      spaceBetween: parseFloat(section.dataset.gap) || 16,
      rewind: true,
      navigation: {
        nextEl: section.querySelector(".swiper-button-next"),
        prevEl: section.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        768: { slidesPerView: parseFloat(section.dataset.show_tablet) || 2 },
        575: { slidesPerView: parseFloat(section.dataset.show_mobile) || 1 },
      },
    });
 
    const slides = swiperEl.querySelectorAll('.swiper-slide');
    let currentIndex = 0;
    let autoplayTimer;
    let isMuted = false;
    let isPaused = false;
    let currentPopupIndex = 0;

    // --- Main video autoplay ---
    function playVideoAt(index) {
      slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (!video) return;
        video.pause();
        video.currentTime = 0;
        if (i === index) {
          video.play().catch(() => {});
          clearTimeout(autoplayTimer);
          autoplayTimer = setTimeout(() => {
            currentIndex = (i + 1) % slides.length;
            swiper.slideToLoop(currentIndex);
            playVideoAt(currentIndex);
          }, 5000);
        }
      });
    }

    playVideoAt(currentIndex);
    swiper.on('slideChange', () => {
      currentIndex = swiper.realIndex;
      playVideoAt(currentIndex);
      // If popup is open, reset popup UI because slide changed
      // if (popup.classList.contains('active')) {
      //   popupProducts.classList.remove('visible');
      //   pauseBtn?.classList.add('hidden');
      // }
    });

    slides.forEach((slide, i) => {
      const video = slide.querySelector('video');
      if (video) video.addEventListener('click', () => openPopupForSlide(i));
    });

    // --- Popup logic ---
    function openPopupForSlide(index) {
      toggleBodyScroll(true);

      const slide = slides[index];
      const videoSrc = slide.dataset.video;
      const productHandleEls = Array.from(slide.querySelectorAll('.product-handle'));
      const rawHandles = productHandleEls.map(el => el.value);

      popup.classList.add('active');
      popupProducts.innerHTML = '';
      popupProducts.classList.remove('visible'); // reset products panel
      pauseBtn?.classList.add('hidden'); // hide pause button
      currentPopupIndex = index;
      isPaused = false;

      popupVideo.src = videoSrc;
      popupVideo.loop = true;
      popupVideo.muted = isMuted;
      popupVideo.currentTime = 0;
      popupVideo.play().catch(() => {});

      updateProgress();
      loadProductSlider(rawHandles);
    }

    function updateProgress() {
      if (!progressBar) return;
      progressBar.style.width = '0%';
      // remove any previously attached handler to avoid duplicates
      popupVideo.removeEventListener('__tolstoy_timeupdate__', timeUpdateHandler);
      popupVideo.addEventListener('timeupdate', timeUpdateHandler);
      function timeUpdateHandler() {
        if (popupVideo.duration > 0) {
          const progress = (popupVideo.currentTime / popupVideo.duration) * 100;
          progressBar.style.width = `${progress}%`;
        }
      }
      // store handler name reference for later removal if necessary
      // (we used a named inner function so removeEventListener can work above)
    }

    async function loadProductSlider(handles) {
      if (!popupProducts) return;

      popupProducts.innerHTML = `
        <div class="popup-product-track swiper">
          <div class="swiper-wrapper"></div>
        </div>
      `;

      const track = popupProducts.querySelector('.swiper-wrapper');
      const validHandles = (Array.isArray(handles) ? handles : [])
        .map(h => (typeof h === 'string' ? h.trim() : ''))
        .filter(h => h.length > 0);

      if (!validHandles.length) {
        popup.classList.add('no-products');
        if (viewProductsBtn) viewProductsBtn.style.display = 'none';
        return;
      }

      popup.classList.remove('no-products');
      if (viewProductsBtn) viewProductsBtn.style.display = '';

      const promises = validHandles.map(async handle => {
        try {
          const res = await fetch(`/products/${handle}.js`);
          if (!res.ok) throw new Error(`Product not found: ${handle}`);
          const data = await res.json();

          const item = document.createElement('div');
          item.classList.add('popup-product-slide', 'swiper-slide');
          item.innerHTML = `
            <div class="popup-product-inner">
              <img src="${data.featured_image}" alt="${data.title}" loading="lazy">
              <div class="popup-prod-info">
                <a href="${data.url}" target="_blank" rel="noopener">${data.title}</a>
                <div class="price">${Shopify.formatMoney(data.price)}</div>
              </div>
            </div>
          `;
          track.appendChild(item);
        } catch (err) {
          console.warn(`[tolstoy] Could not load product ${handle}:`, err);
        }
      });

      await Promise.all(promises);

      // initialize product swiper (shows partial next slide to indicate more)
      const productTrack = popupProducts.querySelector('.popup-product-track');
      if (productTrack) {
        new Swiper(productTrack, {
          slidesPerView: 1,
          spaceBetween: 8,
          centeredSlides: false,
        });
      }
    }

    // --- Popup video pause/play toggle ---
    popupVideo.addEventListener('click', () => {
      if (isPaused) {
        popupVideo.play();
        pauseBtn?.classList.add('hidden');
      } else {
        popupVideo.pause();
        pauseBtn?.classList.remove('hidden');
      }
      isPaused = !isPaused;
    });

    // --- Mute/unmute button ---
    const controlsWrapper = popup.querySelector('.popup-controls');
    if (controlsWrapper) {
      const muteBtn = document.createElement('button');
      muteBtn.className = 'popup-mute-btn';
      muteBtn.innerHTML = `
        <svg class="unmute-icon" width="20" height="17" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.758.867A1.349 1.349 0 0 0 11.25.75c-.313 0-.625.117-.86.352L5.118 5.75H1.875C.82 5.75 0 6.61 0 7.625v3.71c0 1.017.82 1.837 1.875 1.837h3.242l5.274 4.687c.234.313.546.391.859.391.156 0 .313 0 .508-.078.43-.235.742-.664.742-1.172V2c0-.469-.313-.938-.742-1.133Zm-1.133 14.766-4.766-4.258H1.875v-3.71h3.984l4.766-4.259v12.227Zm5.469-9.024a1.053 1.053 0 0 0-.586-.195.962.962 0 0 0-.742.352.942.942 0 0 0 .156 1.328c.43.351.703.86.703 1.406a1.85 1.85 0 0 1-.703 1.445.942.942 0 0 0-.156 1.328.962.962 0 0 0 .742.352c.195 0 .43-.078.586-.195.898-.742 1.406-1.797 1.406-2.93 0-1.094-.508-2.148-1.406-2.89Zm2.383-2.89c-.196-.117-.391-.196-.625-.196-.274 0-.508.118-.704.352-.351.39-.273.977.118 1.328 1.328 1.055 2.109 2.656 2.109 4.297 0 1.68-.781 3.281-2.11 4.336-.39.351-.468.937-.117 1.328.196.234.43.352.704.352.234 0 .43-.079.625-.196 1.757-1.445 2.773-3.554 2.773-5.82 0-2.227-1.016-4.336-2.773-5.781Z" fill="#fff"></path></svg>
        <svg class="mute-icon" width="20" height="20" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.508.867C12.313.79 12.156.79 12 .79c-.313 0-.625.078-.86.313L5.868 5.75H2.625C1.57 5.75.75 6.61.75 7.625v3.71c0 1.017.82 1.837 1.875 1.837h3.242l5.274 4.687c.234.196.546.313.859.313.156 0 .313-.04.508-.117.43-.196.703-.664.703-1.133V2c0-.469-.274-.938-.703-1.133Zm-1.133 14.766-4.766-4.258H2.625v-3.71h3.984l4.766-4.259v12.227ZM20.789 9.5l1.836-1.836c.39-.39.39-.976 0-1.328-.352-.39-.938-.39-1.328 0L19.5 8.21l-1.875-1.875c-.39-.352-.977-.352-1.328 0-.39.39-.39.976 0 1.328L18.133 9.5l-1.836 1.836c-.39.39-.39.976 0 1.328.351.39.937.39 1.328 0l1.875-1.836 1.836 1.836c.352.39.937.39 1.289 0 .39-.351.39-.937 0-1.328L20.789 9.5Z" fill="#fff"></path></svg>
      `;
      controlsWrapper.appendChild(muteBtn);

      muteBtn.addEventListener('click', () => {
        isMuted = !isMuted;
        popupVideo.muted = isMuted;
        muteBtn.classList.toggle('muted', isMuted);
      });
    }

    // --- View products toggle ---
    if (viewProductsBtn && popupProducts) {
      viewProductsBtn.addEventListener('click', () => {
        popupProducts.classList.toggle('visible');
      });
    }

    // --- Next / Prev popup video navigation ---
    function showPopupVideo(dir) {
      popupProducts.classList.remove('visible');
      pauseBtn?.classList.add('hidden');
      currentPopupIndex = (currentPopupIndex + dir + slides.length) % slides.length;
      openPopupForSlide(currentPopupIndex);
    }
    popupNext?.addEventListener('click', () => showPopupVideo(1));
    popupPrev?.addEventListener('click', () => showPopupVideo(-1));

    // --- Wheel navigation (desktop) ---
    let wheelTimer;
    popup.addEventListener('wheel', e => {
      e.preventDefault();
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(() => {
        e.deltaY > 0 ? showPopupVideo(1) : showPopupVideo(-1);
      }, 120);
    }, { passive: false });

    // --- Touch navigation (mobile) ---
    let touchStartY = 0;
    let touchEndY = 0;
    const touchThreshold = 30; 

    popup.addEventListener('touchstart', (e) => {
      if (!e.touches || e.touches.length === 0) return;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    popup.addEventListener('touchend', (e) => {
      touchEndY = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientY : touchEndY;
      const deltaY = touchEndY - touchStartY;
      if (Math.abs(deltaY) < touchThreshold) return;
      if (deltaY > 0) {
        showPopupVideo(-1);
      } else {
        showPopupVideo(1);
      }
    }, { passive: true });

    closeBtn?.addEventListener('click', () => {
      toggleBodyScroll(false);
      popup.classList.remove('active');
      popupProducts.classList.remove('visible');
      pauseBtn?.classList.add('hidden');
      popupVideo.pause();
      popupVideo.src = '';
      if (progressBar) progressBar.style.width = '0%';
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popup.classList.contains('active')) {
        closeBtn?.click();
      }
    });
    // Function to toggle body scroll lock
    function toggleBodyScroll(lock) {
      const body = document.body;
      if (lock) {
        body.classList.add('overflow-hidden');
        // body.style.overflow = 'hidden';
      } else {
        body.classList.remove('overflow-hidden');
        // body.style.overflow = 'auto';
      }
    }
  });
});
